module.exports = __webpack_public_path__ + "static/media/leftArrowLight.79a5ca34.svg";